import { Component, Input } from '@angular/core';


@Component({
  selector: 'lib-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})
export class LibButtonComponent {

  @Input() color: string = 'primary';
  @Input() disabled: boolean = false;
  @Input() fullWidth: boolean = false;

}
